











import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class OptionGroup extends Vue {

	@Prop() options!: string[]
	@Prop() value!: string[]

	input(opt: string, e: Event) {
		if((e.target as HTMLInputElement).checked) {
			this.$emit('input', [...this.value, opt])
		} else {
			const newVal = this.value.slice()
			newVal.splice(this.value.indexOf(opt), 1)
			this.$emit('input', newVal)
		}
	}

}
